export default "__VITE_ASSET__cX86ntpz__"